import { useCallback, useEffect, useMemo, useState } from "react";
import { Card, Table, Tabs, message, Row, Col } from "antd";
import { useColumnTable } from "./table/data.table";
import requets from "../../api";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import ProductNew from "./product.new";
import { useAppAuth } from "../../context/use-app-auth";

export default function Products() {
  const auth = useAppAuth();
  const req = useMemo(
    () => requets(auth.user?.access_token),
    [auth.user?.access_token],
  );
  const { t } = useTranslation("global");
  const [messageSend, contextHolder] = message.useMessage();
  const controlPanel = useSelector((state) => state.controlPanel);
  const [data, setDataSource] = useState([]);

  const getProducts = useCallback(() => {
    req
      .get("/product", {})
      .then((response) => {
        setDataSource(Array.isArray(response.data) ? response.data : []);
      })
      .catch(() => setDataSource([]));
  }, [req]);

  const handleDelete = useCallback(
    (uuid) => {
      req
        .delete(`/product/${uuid}`)
        .then(() => {
          messageSend.success(t("products.successDeleted"));
          getProducts();
        })
        .catch(() => messageSend.error(t("products.errorLoad")));
    },
    [req, messageSend, t, getProducts],
  );

  const columns = useColumnTable(handleDelete);

  useEffect(() => {
    getProducts();
  }, [controlPanel]);

  const items = useMemo(
    () => [
      {
        key: "1",
        label: t("products.products"),
        children: (
          <Table
            columns={columns}
            dataSource={data}
            scroll={{ x: "max-content" }}
            rowKey="uuid"
            size="small"
          />
        ),
      },
      {
        key: "2",
        label: t("products.createProduct"),
        children: <ProductNew onSuccess={getProducts} />,
      },
    ],
    [columns, data, t, getProducts],
  );

  return (
    <div className="layout-content">
      {contextHolder}
      <Row className="rowgap-vbox" gutter={[24, 0]}>
        <Col xs={24} className="mb-24">
          <Card bordered={false}>
            <Tabs defaultActiveKey="1" items={items} />
          </Card>
        </Col>
      </Row>
    </div>
  );
}
